
















































































import { Component, Vue } from 'vue-property-decorator'
@Component({
  components: {}
})
export default class MaterialDesignIcons extends Vue {
  private icons: string[] = [
    'github',
    'microsoft-visual-studio-code',
    'vuejs',
    'vuetify',
    'angularjs',
    'react',
    'google-chrome',
    'firefox',
    'language-typescript',
    'webpack',
    'nodejs'
  ]
  private colorIcons: any[] = [
    {
      icon: 'github',
      color: 'primary'
    },
    {
      icon: 'microsoft-visual-studio-code',
      color: 'accent'
    },
    {
      icon: 'vuejs',
      color: 'secondary'
    },
    {
      icon: 'vuetify',
      color: 'error'
    },
    {
      icon: 'angularjs',
      color: 'warning'
    },
    {
      icon: 'react',
      color: 'info'
    },
    {
      icon: 'google-chrome',
      color: 'success'
    },
    {
      icon: 'firefox',
      color: '#777ccc'
    },
    {
      icon: 'language-typescript',
      color: '#77ccc7'
    },
    {
      icon: 'webpack',
      color: '#ccc777'
    },
    {
      icon: 'nodejs',
      color: '#cc777c'
    }
  ]
  private numberIcons: string[] = [
    'numeric-0',
    'numeric-1',
    'numeric-2',
    'numeric-3',
    'numeric-4',
    'numeric-5',
    'numeric-6',
    'numeric-7',
    'numeric-8',
    'numeric-9',
    'numeric-9-plus'
  ]
}
